import { Col, Row } from "antd";
import React from "react";

const PersistentFooter = () => {
  return (
    <Row className="w-full absolute bottom-0 right-0 py-2 flex justify-end pr-4">
      <Col>
        <span className="text-xs text-gray-500">
          Powered by MYT SoftDev Solutions, Inc.
        </span>
      </Col>
    </Row>
  );
};

export default PersistentFooter;
